import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useFetcher } from './fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DayOfMonth: { input: string; output: string; }
  Money: { input: number; output: number; }
  MoneyTruncated: { input: string; output: string; }
  Month: { input: string; output: string; }
  Percentage: { input: number; output: number; }
  PotName: { input: string; output: string; }
  Year: { input: string; output: string; }
};

export type AccountBalances = {
  __typename: 'AccountBalances';
  /** @deprecated No longer supported */
  deposit: Scalars['MoneyTruncated']['output'];
  depositAccessibleTotal: Scalars['Money']['output'];
  depositIsaAccessPots: Scalars['Money']['output'];
  depositIsaFixedPots: Scalars['Money']['output'];
  depositIsaTotal: Scalars['Money']['output'];
  depositLockedTotal: Scalars['Money']['output'];
  /** @deprecated No longer supported */
  depositNoticePots: Scalars['MoneyTruncated']['output'];
  depositRegularAccessPots: Scalars['Money']['output'];
  depositRegularNoticePots: Scalars['Money']['output'];
  /** @deprecated No longer supported */
  depositRegularPots: Scalars['MoneyTruncated']['output'];
  depositRegularTotal: Scalars['Money']['output'];
  depositTotal: Scalars['MoneyTruncated']['output'];
  interestAccruedTotal: Scalars['MoneyTruncated']['output'];
  interestIsaAccruedTotal: Scalars['Money']['output'];
  interestRegularAccruedTotal: Scalars['Money']['output'];
};

export const ActivityHistoryItemType = {
  ADJUSTMENT_NEGATIVE: 'ADJUSTMENT_NEGATIVE',
  ADJUSTMENT_POSITIVE: 'ADJUSTMENT_POSITIVE',
  BONUS_INTEREST: 'BONUS_INTEREST',
  CASHBACK: 'CASHBACK',
  DEPOSIT: 'DEPOSIT',
  FUNDS_WITHDRAWN_REJECTED: 'FUNDS_WITHDRAWN_REJECTED',
  INTEREST: 'INTEREST',
  INTEREST_CHARGE: 'INTEREST_CHARGE',
  INTEREST_FROM: 'INTEREST_FROM',
  INTEREST_TO: 'INTEREST_TO',
  ISA_TRANSFER_IN: 'ISA_TRANSFER_IN',
  ISA_TRANSFER_OUT: 'ISA_TRANSFER_OUT',
  REFER_A_FRIEND_REWARD: 'REFER_A_FRIEND_REWARD',
  RETURN: 'RETURN',
  TRANSFER_FROM: 'TRANSFER_FROM',
  TRANSFER_TO: 'TRANSFER_TO',
  UNKNOWN: 'UNKNOWN',
  WITHDRAWAL: 'WITHDRAWAL'
} as const;

export type ActivityHistoryItemType = typeof ActivityHistoryItemType[keyof typeof ActivityHistoryItemType];
export type AutoSavePot = {
  __typename: 'AutoSavePot';
  amount: Scalars['Money']['output'];
  potId: Scalars['ID']['output'];
};

export type AutoSavePotInput = {
  amount: Scalars['Money']['input'];
  potId: Scalars['ID']['input'];
};

export type AutoSaveSchedule = {
  __typename: 'AutoSaveSchedule';
  amount?: Maybe<Scalars['Money']['output']>;
  authUri?: Maybe<Scalars['String']['output']>;
  dayOfMonth?: Maybe<Scalars['DayOfMonth']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  fromBankAccount: MemberBankAccountWrapper;
  id: Scalars['ID']['output'];
  moneySplit: Array<AutoSavePot>;
  nextAutoSaveIsSkipped: Scalars['Boolean']['output'];
  nextPaymentDate?: Maybe<Scalars['Date']['output']>;
  paymentDateAfterNextPaymentDate?: Maybe<Scalars['Date']['output']>;
  periodType: ScheduleType;
  potId?: Maybe<Scalars['ID']['output']>;
  status: AutoSaveScheduleStatus;
  toBankAccount: ProductBankAccountWrapper;
  totalAmount: Scalars['Money']['output'];
  transactionReference: Scalars['String']['output'];
};

export const AutoSaveScheduleStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  REPLACED: 'REPLACED'
} as const;

export type AutoSaveScheduleStatus = typeof AutoSaveScheduleStatus[keyof typeof AutoSaveScheduleStatus];
export type AutoSaveSettings = {
  __typename: 'AutoSaveSettings';
  monthlyLimit: Scalars['Money']['output'];
  paymentLimit: Scalars['Money']['output'];
  weeklyLimit: Scalars['Money']['output'];
};

export type BankAccountDocumentUpload = {
  bankAccountId: Scalars['ID']['input'];
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mediaType: Scalars['String']['input'];
};

export type BankAccountInput = {
  accountNumber: Scalars['String']['input'];
  sortCode: Scalars['String']['input'];
};

export const BankAccountStatus = {
  UNCHECKED: 'UNCHECKED',
  UNVERIFIED: 'UNVERIFIED',
  VERIFIED: 'VERIFIED'
} as const;

export type BankAccountStatus = typeof BankAccountStatus[keyof typeof BankAccountStatus];
export type BonusOffer = {
  __typename: 'BonusOffer';
  durationDays?: Maybe<Scalars['Int']['output']>;
  interestRateAER: Scalars['Percentage']['output'];
  interestRateGross: Scalars['Percentage']['output'];
  potTypes: Array<PotType>;
  scope: BonusRateScope;
  trigger: BonusOfferTrigger;
};

export const BonusOfferTrigger = {
  CURRENT_ACCOUNT_TRIGGERED_BONUS_RATE: 'CURRENT_ACCOUNT_TRIGGERED_BONUS_RATE',
  ISA_ACCOUNT_CREATION: 'ISA_ACCOUNT_CREATION',
  ISA_TRANSFER_IN: 'ISA_TRANSFER_IN',
  LIMITED_ACCESS_POT_CREATION: 'LIMITED_ACCESS_POT_CREATION',
  MANUAL_BONUS_RATE_EXTENSION: 'MANUAL_BONUS_RATE_EXTENSION',
  POT_CREATION: 'POT_CREATION',
  TIER_ONE: 'TIER_ONE',
  TIER_THREE: 'TIER_THREE',
  TIER_TWO: 'TIER_TWO'
} as const;

export type BonusOfferTrigger = typeof BonusOfferTrigger[keyof typeof BonusOfferTrigger];
export const BonusRateScope = {
  ACCOUNT: 'ACCOUNT'
} as const;

export type BonusRateScope = typeof BonusRateScope[keyof typeof BonusRateScope];
export type CompleteAutoSaveSettings = {
  __typename: 'CompleteAutoSaveSettings';
  customerCurrentSettings?: Maybe<AutoSaveSettings>;
  maximumAutoSaveSettings: AutoSaveSettings;
};

export const DayOfWeek = {
  FRIDAY: 'FRIDAY',
  MONDAY: 'MONDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
  THURSDAY: 'THURSDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];
export type FixedPotBreakDetails = {
  __typename: 'FixedPotBreakDetails';
  daysOfInterest: Scalars['Int']['output'];
  depositAfterFee: Scalars['Money']['output'];
  fee: Scalars['Money']['output'];
};

export type FixedPotDetails = {
  __typename: 'FixedPotDetails';
  balanceProjectionAtMaturity?: Maybe<Scalars['Money']['output']>;
  maturedInLastThirtyDays: Scalars['Boolean']['output'];
  oldPotType?: Maybe<PotType>;
  startingBalance: Scalars['Money']['output'];
};

export type FixedProjection = {
  __typename: 'FixedProjection';
  interestProjected: Scalars['Money']['output'];
  potType: PotType;
};

export type FundingWindowDetails = {
  __typename: 'FundingWindowDetails';
  fundingPeriodInDays: Scalars['Int']['output'];
  minimumAmount: Scalars['Money']['output'];
};

export type GivenNotice = {
  __typename: 'GivenNotice';
  daysLeft: Scalars['Int']['output'];
  endOfNoticeDate: Scalars['Date']['output'];
};

export type Goal = {
  __typename: 'Goal';
  type: GoalType;
};

export const GoalType = {
  CAR: 'CAR',
  HOLIDAY: 'HOLIDAY',
  NEW_CAR: 'NEW_CAR',
  NEW_HOME: 'NEW_HOME',
  OTHER: 'OTHER',
  RAINY_DAY: 'RAINY_DAY',
  RENOVATIONS: 'RENOVATIONS',
  RETIREMENT: 'RETIREMENT'
} as const;

export type GoalType = typeof GoalType[keyof typeof GoalType];
export const Group = {
  ISA: 'ISA',
  REGULAR: 'REGULAR'
} as const;

export type Group = typeof Group[keyof typeof Group];
export type InterestRateComponents = {
  __typename: 'InterestRateComponents';
  bonusAER: Scalars['Percentage']['output'];
  /** The balance up to which the bonus rate applies. Above this threshold the underlying rate applies. Null when there is no balance cap. */
  bonusAppliesUpToBalance?: Maybe<Scalars['Money']['output']>;
  bonusGross: Scalars['Percentage']['output'];
  underlyingAER: Scalars['Percentage']['output'];
  underlyingGross: Scalars['Percentage']['output'];
};

export type IsaJourney = {
  __typename: 'IsaJourney';
  summary: Scalars['String']['output'];
  termsAndConditions: Scalars['String']['output'];
  unsignedIsaDeclarationCopy: Scalars['String']['output'];
};

export type IsaTaxYearDetails = {
  __typename: 'IsaTaxYearDetails';
  /** Annual ISA allowance */
  annualAllowance: Scalars['Money']['output'];
  daysLeftTillEndDate: Scalars['Int']['output'];
  endDate: Scalars['Date']['output'];
  taxYear: Scalars['String']['output'];
};

export type IsaTransferInDetails = {
  __typename: 'IsaTransferInDetails';
  estimatedCompletionDate: Scalars['Date']['output'];
  finalisedOn?: Maybe<Scalars['Date']['output']>;
  isaProvider: Scalars['String']['output'];
  requestedOn: Scalars['Date']['output'];
  status: IsaTransferInStatus;
  transferAmount: Scalars['Money']['output'];
};

export const IsaTransferInStatus = {
  ACCEPTED: 'ACCEPTED',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  ON_HOLD: 'ON_HOLD',
  ON_HOLD_ACTION_REQUIRED: 'ON_HOLD_ACTION_REQUIRED',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED'
} as const;

export type IsaTransferInStatus = typeof IsaTransferInStatus[keyof typeof IsaTransferInStatus];
export type IsaWrapper = {
  __typename: 'IsaWrapper';
  allowance: Scalars['Money']['output'];
  closedDate?: Maybe<Scalars['Date']['output']>;
  isWithinCancellationPeriod: Scalars['Boolean']['output'];
  isaTermsAndConditions: Scalars['String']['output'];
  openedDate: Scalars['Date']['output'];
  reference: Scalars['String']['output'];
  subscriptionDetails?: Maybe<SubscriptionDetails>;
};

export type Journey = {
  __typename: 'Journey';
  checkYourDetailsRequired: Scalars['Boolean']['output'];
  checkYourTaxStatusRequired: Scalars['Boolean']['output'];
  evidenceProvided: Scalars['Boolean']['output'];
  evidenceRequired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  interestRateAER: Scalars['Percentage']['output'];
  maximumBalance: Scalars['MoneyTruncated']['output'];
  selectedBankAccount?: Maybe<MemberBankAccount>;
  summary: Scalars['String']['output'];
  termsAndConditions?: Maybe<Scalars['String']['output']>;
};

/**
 * Configuration for a single level within a Limited Access pot product.
 * Level 1 is the standard rate with a withdrawal allowance; Level 2 is the penalty rate
 * applied after the allowance is exceeded, with no further withdrawal limit.
 */
export type LimitedAccessLevel = {
  __typename: 'LimitedAccessLevel';
  interestRateAER: Scalars['Percentage']['output'];
  /** Present on Level 1 where a bonus rate applies up to a balance cap. Null on Level 2. */
  interestRateBonusComponents?: Maybe<InterestRateComponents>;
  interestRateGross: Scalars['Percentage']['output'];
  level: Scalars['Int']['output'];
  /** Maximum withdrawals before the pot downgrades to the next level. Null means no relevant limit (Level 2). */
  withdrawalCountAllowance?: Maybe<Scalars['Int']['output']>;
};

/**
 * Product-level catalog configuration for a Limited Access pot — the static definition of levels,
 * rates, and withdrawal allowances. Parallels TieredPotDetails/Tier for tiered pots.
 */
export type LimitedAccessPotDetails = {
  __typename: 'LimitedAccessPotDetails';
  limitedAccessLevels: Array<LimitedAccessLevel>;
};

/**
 * Withdrawal counts within the current renewal period for a Limited Access pot at Level 1.
 * All three counts are provided so the UI needs no arithmetic.
 */
export type LimitedAccessWithdrawalCounts = {
  __typename: 'LimitedAccessWithdrawalCounts';
  /** Maximum withdrawals permitted in the current period before the pot downgrades to Level 2. */
  allowance: Scalars['Int']['output'];
  madeInCurrentPeriod: Scalars['Int']['output'];
  remainingInCurrentPeriod: Scalars['Int']['output'];
};

/**
 * Per-pot live withdrawal state for a Limited Access pot.
 * withdrawalCounts is null when the pot has been downgraded to Level 2 (penalty rate) — the period dates
 * are still present so the UI can show the renewal date even without counts.
 */
export type LimitedAccessWithdrawalDetails = {
  __typename: 'LimitedAccessWithdrawalDetails';
  /** End of the current 365-day renewal window; counts reset when this date is reached. */
  currentPeriodEndDate: Scalars['Date']['output'];
  /** Start of the current 365-day renewal window. */
  currentPeriodStartDate: Scalars['Date']['output'];
  /** Null when the pot is at Level 2 (withdrawal allowance exceeded). */
  withdrawalCounts?: Maybe<LimitedAccessWithdrawalCounts>;
};

export type MemberAssignment = {
  __typename: 'MemberAssignment';
  assignedJourney: Journey;
  replacedJourney?: Maybe<Journey>;
};

export type MemberBankAccount = {
  __typename: 'MemberBankAccount';
  accountNumberEnding: Scalars['String']['output'];
  autoSavingCompatible: Scalars['Boolean']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  documentUploadCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  openBankingCompatible: Scalars['Boolean']['output'];
  sortCode: Scalars['String']['output'];
  validationStatus: BankAccountStatus;
};

export type MemberBankAccountWrapper = {
  __typename: 'MemberBankAccountWrapper';
  details: MemberBankAccount;
  id: Scalars['ID']['output'];
};

export const MemberVerificationStatus = {
  FAILED: 'FAILED',
  PASSED: 'PASSED',
  REFERRED: 'REFERRED',
  REFERRED_EVIDENCE_REQUIRED: 'REFERRED_EVIDENCE_REQUIRED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type MemberVerificationStatus = typeof MemberVerificationStatus[keyof typeof MemberVerificationStatus];
export type MonthlyStatement = {
  __typename: 'MonthlyStatement';
  statement: Scalars['Month']['output'];
  year: Scalars['Year']['output'];
};

export type MonthlyStatements = {
  __typename: 'MonthlyStatements';
  statements: Array<Scalars['Month']['output']>;
  year: Scalars['Year']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  assignJourney: MemberAssignment;
  breakFixedPot: Scalars['ID']['output'];
  cancelIsaTransferIn: Scalars['ID']['output'];
  cancelNoticeOnPot: Pot;
  cancelScheduledDeposit: AutoSaveSchedule;
  changePotGoal: Pot;
  changeToNoticePot: Pot;
  closeAccount: Scalars['ID']['output'];
  closeIsaZone: Scalars['ID']['output'];
  completeJourney: Scalars['ID']['output'];
  confirmTaxResidency: SavingsApplication;
  createBankAccount: Scalars['ID']['output'];
  createIsaZone: IsaWrapper;
  createNewPot: Pot;
  createPotFromExistingPotWithBalance: Pot;
  createScheduledDeposit: AutoSaveSchedule;
  declareUkTaxResidentOnly: Scalars['ID']['output'];
  deletePot: Scalars['ID']['output'];
  editScheduledDeposit: AutoSaveSchedule;
  expectedDepositAmount: Scalars['ID']['output'];
  giveNoticeOnPot: Pot;
  initiateOpenBankingPayment: OpenBankingPayment;
  isaTransferIn: Scalars['ID']['output'];
  limitedAccessSummary: Scalars['String']['output'];
  regularFixedSummary: Scalars['String']['output'];
  regularSaverSummary: Scalars['String']['output'];
  regularTieredAccessSummary: Scalars['String']['output'];
  renamePot: Pot;
  selectJourneyBankAccount: Scalars['ID']['output'];
  signIsaDeclaration: Scalars['ID']['output'];
  skipScheduledDeposit: AutoSaveSchedule;
  sourceOfFunds: Scalars['ID']['output'];
  startApplication: SavingsApplication;
  startIsaZoneJourney: IsaJourney;
  startJourney: Journey;
  submitApplication: Scalars['ID']['output'];
  toggleInterestRouter: Scalars['ID']['output'];
  transferBetweenPots: Scalars['ID']['output'];
  upload: Scalars['ID']['output'];
  withdraw: Scalars['ID']['output'];
  /** @deprecated Use withdraw instead */
  withdrawFromPot: Scalars['ID']['output'];
};


export type MutationAssignJourneyArgs = {
  journeyId: Scalars['ID']['input'];
};


export type MutationBreakFixedPotArgs = {
  beneficiaryBankAccountId?: InputMaybe<Scalars['ID']['input']>;
  potId: Scalars['ID']['input'];
};


export type MutationCancelIsaTransferInArgs = {
  potId: Scalars['ID']['input'];
};


export type MutationCancelNoticeOnPotArgs = {
  potId: Scalars['ID']['input'];
};


export type MutationCancelScheduledDepositArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationChangePotGoalArgs = {
  newType: GoalType;
  potId: Scalars['ID']['input'];
};


export type MutationChangeToNoticePotArgs = {
  noticePotOptionId: PotOptionId;
  potId: Scalars['ID']['input'];
};


export type MutationCloseAccountArgs = {
  withdrawalBankAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCloseIsaZoneArgs = {
  beneficiaryBankAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateBankAccountArgs = {
  bankAccount: BankAccountInput;
};


export type MutationCreateNewPotArgs = {
  goalType?: InputMaybe<GoalType>;
  interestRouterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['PotName']['input'];
  potType: PotType;
};


export type MutationCreatePotFromExistingPotWithBalanceArgs = {
  amount: Scalars['Money']['input'];
  goalType?: InputMaybe<GoalType>;
  name: Scalars['PotName']['input'];
  potId: Scalars['ID']['input'];
  potType: PotType;
};


export type MutationCreateScheduledDepositArgs = {
  bankAccountId: Scalars['ID']['input'];
  dayOfMonth?: InputMaybe<Scalars['DayOfMonth']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  moneySplit?: InputMaybe<Array<AutoSavePotInput>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  scheduleType: ScheduleType;
};


export type MutationDeclareUkTaxResidentOnlyArgs = {
  declaration: Scalars['Boolean']['input'];
};


export type MutationDeletePotArgs = {
  potId: Scalars['ID']['input'];
};


export type MutationEditScheduledDepositArgs = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  dayOfMonth?: InputMaybe<Scalars['DayOfMonth']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  moneySplit?: InputMaybe<Array<AutoSavePotInput>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['ID']['input'];
  scheduleType: ScheduleType;
};


export type MutationExpectedDepositAmountArgs = {
  amount: Scalars['Money']['input'];
};


export type MutationGiveNoticeOnPotArgs = {
  potId: Scalars['ID']['input'];
};


export type MutationInitiateOpenBankingPaymentArgs = {
  amount: Scalars['MoneyTruncated']['input'];
  bankAccountId: Scalars['ID']['input'];
  potId?: InputMaybe<Scalars['ID']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIsaTransferInArgs = {
  accountReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccount?: InputMaybe<BankAccountInput>;
  currentSubscriptionAmount?: InputMaybe<Scalars['Money']['input']>;
  isaProvider: Scalars['String']['input'];
  maturityDate?: InputMaybe<Scalars['Date']['input']>;
  transferAmount: Scalars['Money']['input'];
  transferAmountDescription: TransferAmountDescription;
  transferInstruction: TransferInstruction;
};


export type MutationRenamePotArgs = {
  newName: Scalars['PotName']['input'];
  potId: Scalars['ID']['input'];
};


export type MutationSelectJourneyBankAccountArgs = {
  bankAccountId: Scalars['ID']['input'];
};


export type MutationSkipScheduledDepositArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationSourceOfFundsArgs = {
  sourceOfFunds?: InputMaybe<SourceOfFunds>;
};


export type MutationSubmitApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationToggleInterestRouterArgs = {
  enabled: Scalars['Boolean']['input'];
  potId: Scalars['ID']['input'];
};


export type MutationTransferBetweenPotsArgs = {
  amount: Scalars['MoneyTruncated']['input'];
  fromPotId: Scalars['ID']['input'];
  toPotId: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  documentUpload: BankAccountDocumentUpload;
};


export type MutationWithdrawArgs = {
  amount: Scalars['Money']['input'];
  beneficiaryBankAccountId: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
  potId: Scalars['ID']['input'];
};


export type MutationWithdrawFromPotArgs = {
  amount: Scalars['MoneyTruncated']['input'];
  beneficiaryBankAccountId: Scalars['ID']['input'];
  potId: Scalars['ID']['input'];
};

export type OpenBankingPayment = {
  __typename: 'OpenBankingPayment';
  amount: Scalars['MoneyTruncated']['output'];
  authUri: Scalars['String']['output'];
  globalPaymentId?: Maybe<Scalars['ID']['output']>;
  paymentId: Scalars['ID']['output'];
  remitterReference: Scalars['String']['output'];
  status: OpenBankingPaymentStatus;
};

export const OpenBankingPaymentStatus = {
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  NEW: 'NEW',
  REJECTED: 'REJECTED',
  SENT: 'SENT'
} as const;

export type OpenBankingPaymentStatus = typeof OpenBankingPaymentStatus[keyof typeof OpenBankingPaymentStatus];
export type OpenFundingWindow = {
  __typename: 'OpenFundingWindow';
  daysLeft: Scalars['Int']['output'];
  endDate: Scalars['Date']['output'];
  hasMinimumAmount: Scalars['Boolean']['output'];
};

export type PostTermEndDetails = {
  __typename: 'PostTermEndDetails';
  daysSinceTermEnd: Scalars['Int']['output'];
  interestEarnedDuringTerm: Scalars['Money']['output'];
  previousPotProduct: Product;
  termEndType: TransitionType;
  transitionedAt: Scalars['DateTime']['output'];
};

export type Pot = {
  __typename: 'Pot';
  balances: PotBalances;
  breakDetails?: Maybe<FixedPotBreakDetails>;
  canHaveAutoSave: Scalars['Boolean']['output'];
  createdDate: Scalars['Date']['output'];
  currentTier?: Maybe<Tier>;
  fixedPotDetails?: Maybe<FixedPotDetails>;
  givenNotice?: Maybe<GivenNotice>;
  goal?: Maybe<Goal>;
  hasAutoSave: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inboundPaymentReference?: Maybe<Scalars['String']['output']>;
  interestEarned: Scalars['Money']['output'];
  interestRouterEnabled: Scalars['Boolean']['output'];
  interestRouterFirstEnabled?: Maybe<Scalars['DateTime']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  isaTransferInDetails?: Maybe<IsaTransferInDetails>;
  limitedAccessWithdrawalDetails?: Maybe<LimitedAccessWithdrawalDetails>;
  name: Scalars['PotName']['output'];
  nextMonthiversary: Scalars['Date']['output'];
  openFundingWindow?: Maybe<OpenFundingWindow>;
  option: PotOption;
  regularSaverDetails?: Maybe<RegularSaverDetails>;
  regularSaverTransitionDetails?: Maybe<RegularSaverTransitionDetails>;
  standingOrders: Array<StandingOrder>;
  termEndDetails?: Maybe<TermEndDetails>;
  transactionHistory: Array<TransactionItem>;
  typeDetails: PotTypeDetails;
};


export type PotTransactionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  transactionTypes?: InputMaybe<Array<ActivityHistoryItemType>>;
};

export type PotBalances = {
  __typename: 'PotBalances';
  deposit: Scalars['Money']['output'];
  interestAccrued: Scalars['Money']['output'];
};

export type PotOption = {
  __typename: 'PotOption';
  id: PotOptionId;
  interestRateAER: Scalars['Percentage']['output'];
  interestRateGross: Scalars['Percentage']['output'];
  requiredNoticeInDays?: Maybe<Scalars['Int']['output']>;
};

export const PotOptionId = {
  NOTICE7: 'NOTICE7',
  NOTICE31: 'NOTICE31',
  NOTICE95: 'NOTICE95',
  REGULAR: 'REGULAR'
} as const;

export type PotOptionId = typeof PotOptionId[keyof typeof PotOptionId];
export type PotRateEntry = {
  __typename: 'PotRateEntry';
  interestRateAER: Scalars['Percentage']['output'];
  interestRateGross: Scalars['Percentage']['output'];
  validFrom: Scalars['Date']['output'];
  validTo?: Maybe<Scalars['Date']['output']>;
};

/** replacing PotOptionId */
export const PotType = {
  ISA_ACCESS: 'ISA_ACCESS',
  ISA_FIXED_1: 'ISA_FIXED_1',
  ISA_FIXED_2: 'ISA_FIXED_2',
  ISA_FIXED_3: 'ISA_FIXED_3',
  ISA_FIXED_4: 'ISA_FIXED_4',
  ISA_FIXED_5: 'ISA_FIXED_5',
  ISA_SUBSCRIPTION: 'ISA_SUBSCRIPTION',
  LIMITED_ACCESS_LEVEL_1: 'LIMITED_ACCESS_LEVEL_1',
  LIMITED_ACCESS_LEVEL_2: 'LIMITED_ACCESS_LEVEL_2',
  REGULAR_ACCESS: 'REGULAR_ACCESS',
  REGULAR_FIXED_1: 'REGULAR_FIXED_1',
  REGULAR_FIXED_2: 'REGULAR_FIXED_2',
  REGULAR_FIXED_3: 'REGULAR_FIXED_3',
  REGULAR_FIXED_4: 'REGULAR_FIXED_4',
  REGULAR_FIXED_5: 'REGULAR_FIXED_5',
  REGULAR_FIXED_6_MONTHS: 'REGULAR_FIXED_6_MONTHS',
  REGULAR_NOTICE_7: 'REGULAR_NOTICE_7',
  REGULAR_NOTICE_31: 'REGULAR_NOTICE_31',
  REGULAR_NOTICE_95: 'REGULAR_NOTICE_95',
  REGULAR_SAVER_ACCESS: 'REGULAR_SAVER_ACCESS',
  REGULAR_SAVER_ACCESS_6_MONTHS: 'REGULAR_SAVER_ACCESS_6_MONTHS',
  REGULAR_TIERED_ACCESS: 'REGULAR_TIERED_ACCESS',
  TIERED_ACCESS_TIER_ONE: 'TIERED_ACCESS_TIER_ONE',
  TIERED_ACCESS_TIER_THREE: 'TIERED_ACCESS_TIER_THREE',
  TIERED_ACCESS_TIER_TWO: 'TIERED_ACCESS_TIER_TWO'
} as const;

export type PotType = typeof PotType[keyof typeof PotType];
/** replacing PotOption */
export type PotTypeDetails = {
  __typename: 'PotTypeDetails';
  group: Group;
  interestRateAER: Scalars['Percentage']['output'];
  interestRateBonusComponents?: Maybe<InterestRateComponents>;
  interestRateGross: Scalars['Percentage']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  limitedAccessPotDetails?: Maybe<LimitedAccessPotDetails>;
  lockPeriodInDays?: Maybe<Scalars['Int']['output']>;
  potType: PotType;
  product: Product;
  termLengthInDays?: Maybe<Scalars['Int']['output']>;
  tieredPotDetails?: Maybe<TieredPotDetails>;
};

export type PotTypeRatesHistory = {
  __typename: 'PotTypeRatesHistory';
  group: Group;
  level?: Maybe<Scalars['Int']['output']>;
  lockPeriodInDays?: Maybe<Scalars['Int']['output']>;
  potRates?: Maybe<Array<Maybe<PotRateEntry>>>;
  product: Product;
  termLengthInDays?: Maybe<Scalars['Int']['output']>;
};

export type PreTermEndDetails = {
  __typename: 'PreTermEndDetails';
  daysUntilTermEnd: Scalars['Int']['output'];
};

export const Product = {
  ACCESS: 'ACCESS',
  FIXED: 'FIXED',
  LIMITED_ACCESS: 'LIMITED_ACCESS',
  NOTICE: 'NOTICE',
  REGULAR_SAVER_ACCESS: 'REGULAR_SAVER_ACCESS',
  TIERED_ACCESS: 'TIERED_ACCESS'
} as const;

export type Product = typeof Product[keyof typeof Product];
export type ProductBankAccount = {
  __typename: 'ProductBankAccount';
  accountNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sortCode: Scalars['String']['output'];
};

export type ProductBankAccountWrapper = {
  __typename: 'ProductBankAccountWrapper';
  details: ProductBankAccount;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename: 'Query';
  account?: Maybe<SavingsAccount>;
  accounts: Array<SavingsAccount>;
  activeScheduledDeposit?: Maybe<AutoSaveSchedule>;
  /**
   * The member's current Savings application, or null if there is none.
   * COMPLETED and FAILED applications are also returned.
   */
  application?: Maybe<SavingsApplication>;
  autoSaveScheduleStatusByMandateId?: Maybe<AutoSaveScheduleStatus>;
  autoSaveSettings: AutoSaveSettings;
  availableBonusOffers: Array<BonusOffer>;
  availablePotOptions: Array<PotOption>;
  availablePotTypesWithDetails: Array<PotTypeDetails>;
  bankAccounts: Array<MemberBankAccount>;
  calculateFixedInterestProjections: Array<FixedProjection>;
  closedIsaZones: Array<IsaWrapper>;
  completeAutoSaveSettings: CompleteAutoSaveSettings;
  fundingWindowDetails: FundingWindowDetails;
  hasOpenZopaBankAccount: Scalars['Boolean']['output'];
  isOpenAccountMoneyMovementInProgress: Scalars['Boolean']['output'];
  isaProviders: Array<Scalars['String']['output']>;
  isaTaxYearDetails: IsaTaxYearDetails;
  isaZoneJourney?: Maybe<IsaJourney>;
  journey?: Maybe<Journey>;
  maximumPotRatesWithBonusOffers: Array<PotTypeDetails>;
  memberVerificationStatus: MemberVerificationStatus;
  openAccount?: Maybe<SavingsAccount>;
  openAccountPot?: Maybe<Pot>;
  openBankingPaymentStatus?: Maybe<OpenBankingPaymentStatus>;
  simplifiedRateHistory?: Maybe<Array<Maybe<PotTypeRatesHistory>>>;
  statements: Statements;
  withdrawalStatus?: Maybe<WithdrawalStatus>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutoSaveScheduleStatusByMandateIdArgs = {
  mandateId: Scalars['ID']['input'];
};


export type QueryAvailableBonusOffersArgs = {
  trigger?: InputMaybe<BonusOfferTrigger>;
};


export type QueryAvailablePotTypesWithDetailsArgs = {
  group?: InputMaybe<Group>;
  products?: InputMaybe<Array<Product>>;
};


export type QueryBankAccountsArgs = {
  openBankingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  showProductBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCalculateFixedInterestProjectionsArgs = {
  amount: Scalars['Money']['input'];
};


export type QueryOpenAccountPotArgs = {
  potId: Scalars['ID']['input'];
};


export type QueryOpenBankingPaymentStatusArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryWithdrawalStatusArgs = {
  idempotencyKey: Scalars['ID']['input'];
};

export type RegularSaverDetails = {
  __typename: 'RegularSaverDetails';
  allowanceRemaining: Scalars['Money']['output'];
  /** @deprecated Not used and should never be used, will be removed in future release */
  finalMonthOfTerm: Scalars['Boolean']['output'];
  monthlyAllowance: Scalars['Money']['output'];
};

export type RegularSaverTransitionDetails = {
  __typename: 'RegularSaverTransitionDetails';
  transitionedAt: Scalars['DateTime']['output'];
  type: TransitionType;
};

export type SavingsAccount = {
  __typename: 'SavingsAccount';
  balances: AccountBalances;
  bankAccount: ProductBankAccount;
  certificatesOfInterest: Array<TaxYear>;
  closedDate?: Maybe<Scalars['Date']['output']>;
  hasFundingHistory: Scalars['Boolean']['output'];
  hasIsa: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isa?: Maybe<IsaWrapper>;
  maximumBalance: Scalars['MoneyTruncated']['output'];
  nextInterestPaymentDate: Scalars['Date']['output'];
  openedDate: Scalars['Date']['output'];
  pots: Array<Pot>;
  remainingBalance: Scalars['MoneyTruncated']['output'];
  sourceOfFundsRequiredPaymentId?: Maybe<Scalars['ID']['output']>;
  termsAndConditions: Scalars['String']['output'];
  totalInterestEarned: Scalars['Money']['output'];
};

export type SavingsApplication = {
  __typename: 'SavingsApplication';
  checkYourDetailsRequired: Scalars['Boolean']['output'];
  checkYourTaxStatusRequired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  referralRedirectUrl?: Maybe<Scalars['String']['output']>;
  status: SavingsApplicationStatus;
  summary?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
};

export const SavingsApplicationStatus = {
  AWAITING_VERIFICATION: 'AWAITING_VERIFICATION',
  COMPLETED: 'COMPLETED',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  REFERRAL_REQUIRED: 'REFERRAL_REQUIRED',
  USER_SUBMITTED: 'USER_SUBMITTED',
  VERIFICATION_APPROVED: 'VERIFICATION_APPROVED'
} as const;

export type SavingsApplicationStatus = typeof SavingsApplicationStatus[keyof typeof SavingsApplicationStatus];
export const ScheduleType = {
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY'
} as const;

export type ScheduleType = typeof ScheduleType[keyof typeof ScheduleType];
export const SourceOfFunds = {
  COURT_AWARD: 'COURT_AWARD',
  DIVIDENDS: 'DIVIDENDS',
  DIVORCE: 'DIVORCE',
  GIFT: 'GIFT',
  INHERITANCE: 'INHERITANCE',
  INSURANCE: 'INSURANCE',
  LIFE_ASSURANCE_POLICY: 'LIFE_ASSURANCE_POLICY',
  LOAN: 'LOAN',
  OTHER: 'OTHER',
  SALARY: 'SALARY',
  SALE_INVESTMENTS: 'SALE_INVESTMENTS',
  SALE_PROPERTY: 'SALE_PROPERTY',
  SAVINGS: 'SAVINGS',
  WINNINGS: 'WINNINGS'
} as const;

export type SourceOfFunds = typeof SourceOfFunds[keyof typeof SourceOfFunds];
export type StandingOrder = {
  __typename: 'StandingOrder';
  amount: Scalars['Money']['output'];
  nextPaymentDate: Scalars['Date']['output'];
  standingOrderId: Scalars['ID']['output'];
};

export type Statements = {
  __typename: 'Statements';
  monthToDateStatement: MonthlyStatement;
  monthlyStatements: Array<MonthlyStatements>;
  taxStatements: Array<Scalars['Year']['output']>;
};

export type SubscriptionDetails = {
  __typename: 'SubscriptionDetails';
  currentSubscription: Scalars['Money']['output'];
  subscriptionStartDate?: Maybe<Scalars['Date']['output']>;
};

export type TaxYear = {
  __typename: 'TaxYear';
  endYear: Scalars['Year']['output'];
  pdfYear: Scalars['Year']['output'];
  startYear: Scalars['Year']['output'];
};

export type TermEndDetails = {
  __typename: 'TermEndDetails';
  postTermEnd?: Maybe<PostTermEndDetails>;
  preTermEnd?: Maybe<PreTermEndDetails>;
  termEndDate: Scalars['Date']['output'];
};

export type Tier = {
  __typename: 'Tier';
  interestRateAER: Scalars['Percentage']['output'];
  interestRateGross: Scalars['Percentage']['output'];
  level: Scalars['Int']['output'];
  lowerBound: Scalars['Money']['output'];
  upperBound?: Maybe<Scalars['Money']['output']>;
};

export type TieredPotDetails = {
  __typename: 'TieredPotDetails';
  tiers: Array<Tier>;
};

export type TransactionItem = {
  __typename: 'TransactionItem';
  amount: Scalars['MoneyTruncated']['output'];
  balance: Scalars['MoneyTruncated']['output'];
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  type: ActivityHistoryItemType;
};

export const TransferAmountDescription = {
  CURRENT_YEAR_SUBSCRIPTION: 'CURRENT_YEAR_SUBSCRIPTION',
  PARTIAL_BALANCE_CURRENT_SUBSCRIPTION_INCLUDED: 'PARTIAL_BALANCE_CURRENT_SUBSCRIPTION_INCLUDED',
  PARTIAL_BALANCE_CURRENT_SUBSCRIPTION_NOT_INCLUDED: 'PARTIAL_BALANCE_CURRENT_SUBSCRIPTION_NOT_INCLUDED',
  WHOLE_BALANCE: 'WHOLE_BALANCE'
} as const;

export type TransferAmountDescription = typeof TransferAmountDescription[keyof typeof TransferAmountDescription];
export const TransferInstruction = {
  FUNDS_ACCESSIBLE_NO_INSTRUCTION: 'FUNDS_ACCESSIBLE_NO_INSTRUCTION',
  FUNDS_LOCKED_CARRY_OUT_ASAP: 'FUNDS_LOCKED_CARRY_OUT_ASAP',
  FUNDS_LOCKED_WAIT_FOR_MATURITY: 'FUNDS_LOCKED_WAIT_FOR_MATURITY'
} as const;

export type TransferInstruction = typeof TransferInstruction[keyof typeof TransferInstruction];
export const TransitionType = {
  FORCED: 'FORCED',
  MATURITY: 'MATURITY'
} as const;

export type TransitionType = typeof TransitionType[keyof typeof TransitionType];
export const WithdrawalStatus = {
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED'
} as const;

export type WithdrawalStatus = typeof WithdrawalStatus[keyof typeof WithdrawalStatus];
export type ClimbersRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClimbersRatesQuery = { __typename: 'Query', simplifiedRateHistory?: Array<{ __typename: 'PotTypeRatesHistory', group: Group, product: Product, level?: number | null, lockPeriodInDays?: number | null, potRates?: Array<{ __typename: 'PotRateEntry', interestRateAER: number, interestRateGross: number, validFrom: string, validTo?: string | null } | null> | null } | null> | null };

export type HistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type HistoryQuery = { __typename: 'Query', simplifiedRateHistory?: Array<{ __typename: 'PotTypeRatesHistory', group: Group, product: Product, lockPeriodInDays?: number | null, potRates?: Array<{ __typename: 'PotRateEntry', interestRateAER: number, interestRateGross: number, validFrom: string, validTo?: string | null } | null> | null } | null> | null };

export type PotOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PotOptionsQuery = { __typename: 'Query', maximumPotRatesWithBonusOffers: Array<{ __typename: 'PotTypeDetails', potType: PotType, group: Group, product: Product, lockPeriodInDays?: number | null, interestRateAER: number, interestRateGross: number, interestRateBonusComponents?: { __typename: 'InterestRateComponents', underlyingAER: number, underlyingGross: number } | null }> };



export const ClimbersRatesDocument = `
    query climbersRates {
  simplifiedRateHistory {
    group
    product
    level
    lockPeriodInDays
    potRates {
      interestRateAER
      interestRateGross
      validFrom
      validTo
    }
  }
}
    `;

export const useClimbersRatesQuery = <
      TData = ClimbersRatesQuery,
      TError = AxiosError
    >(
      variables?: ClimbersRatesQueryVariables,
      options?: Omit<UseQueryOptions<ClimbersRatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClimbersRatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClimbersRatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['climbersRates'] : ['climbersRates', variables],
    queryFn: useFetcher<ClimbersRatesQuery, ClimbersRatesQueryVariables>(ClimbersRatesDocument).bind(null, variables),
    ...options
  }
    )};

useClimbersRatesQuery.getKey = (variables?: ClimbersRatesQueryVariables) => variables === undefined ? ['climbersRates'] : ['climbersRates', variables];

export const HistoryDocument = `
    query history {
  simplifiedRateHistory {
    group
    product
    lockPeriodInDays
    potRates {
      interestRateAER
      interestRateGross
      validFrom
      validTo
    }
  }
}
    `;

export const useHistoryQuery = <
      TData = HistoryQuery,
      TError = AxiosError
    >(
      variables?: HistoryQueryVariables,
      options?: Omit<UseQueryOptions<HistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HistoryQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['history'] : ['history', variables],
    queryFn: useFetcher<HistoryQuery, HistoryQueryVariables>(HistoryDocument).bind(null, variables),
    ...options
  }
    )};

useHistoryQuery.getKey = (variables?: HistoryQueryVariables) => variables === undefined ? ['history'] : ['history', variables];

export const PotOptionsDocument = `
    query potOptions {
  maximumPotRatesWithBonusOffers {
    potType
    group
    product
    lockPeriodInDays
    interestRateAER
    interestRateGross
    interestRateBonusComponents {
      underlyingAER
      underlyingGross
    }
  }
}
    `;

export const usePotOptionsQuery = <
      TData = PotOptionsQuery,
      TError = AxiosError
    >(
      variables?: PotOptionsQueryVariables,
      options?: Omit<UseQueryOptions<PotOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PotOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PotOptionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['potOptions'] : ['potOptions', variables],
    queryFn: useFetcher<PotOptionsQuery, PotOptionsQueryVariables>(PotOptionsDocument).bind(null, variables),
    ...options
  }
    )};

usePotOptionsQuery.getKey = (variables?: PotOptionsQueryVariables) => variables === undefined ? ['potOptions'] : ['potOptions', variables];
